import React from "react";
import { Component } from "react";
import { InputFieldFloatingLabel as InputField } from "../../../common/custom-form/select-filter.component";
import Translation from "../../../common/translation/translation.component";
import { MAX_LENGTH } from "../../../../constants/external-constants";
import { isDisabledPerRequestType } from '../../../../utils/helpers.utils';
import CustomSearchableDropdownWrapper from "../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

export class AddressDetails extends Component {

    render() {
        const { completed, locationDetails, translator, inventoryAllLocations, 
            fieldProp, onChangeAction, showDemarcLoc = true, areFieldsDisabled = true, isRequired = false, 
            isCircuitOrder, formName, requestTypeId, isLocationLoading, hasMoreLocation, handleLocationSearch, loadMoreLocation } = this.props;
        return (
            <div className="details-4-col-container address-detail-container">                
                <CustomSearchableDropdownWrapper
                    label={<Translation translationKey={"location_site_id_capital"} />}
                    options={inventoryAllLocations}
                    isNullable={true}
                    selected={locationDetails.locationID}
                    onChange={(value) => onChangeAction(`${fieldProp}.locationID`, value)}
                    placeholder={isDisabledPerRequestType(requestTypeId, 'locationID') ? '' : `${translator('select_placeholder')}`}
                    fieldProp={`${fieldProp}.locationID`}
                    tagName={`${fieldProp}.locationSite`}
                    optionLabelKey={{
                        Key: 'LocationId',
                        Value: 'LocationSite'
                    }}
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={completed || isDisabledPerRequestType(requestTypeId, 'locationID')}
                    onSearchChange={handleLocationSearch}
                    onLoadMore={loadMoreLocation}
                    isLoading={isLocationLoading}
                    hasMore={hasMoreLocation}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"address_1_capital"} />}
                    value={locationDetails.address1}
                    fieldProp={`${fieldProp}.address1`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"address_2_capital"} />}
                    value={locationDetails.address2}
                    fieldProp={`${fieldProp}.address2`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"location_type_capital"} />}
                    value={locationDetails.locationType}
                    fieldProp={`${fieldProp}.locationType`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                />
                <InputField
                    className={`form-control ${isRequired? "required" : ""}`}
                    type="text"
                    label={<Translation translationKey={"city_capital"} />}
                    value={locationDetails.locationCity}
                    fieldProp={`${fieldProp}.locationCity`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                    requiredField={isRequired}
                />
                <InputField
                    className={`form-control ${isRequired? "required" : ""}`}
                    type="text"
                    label={<Translation translationKey={"state_capital"} />}
                    value={locationDetails.locationState}
                    fieldProp={`${fieldProp}.locationState`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                    requiredField={isRequired}
                />
                <InputField
                    className={`form-control ${isRequired? "required" : ""}`}
                    type="text"
                    label={<Translation translationKey={"country_capital"} />}
                    value={locationDetails.locationCountry}
                    fieldProp={`${fieldProp}.locationCountry`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                    requiredField={isRequired}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={"zip_capital"} />}
                    value={locationDetails.locationZip}
                    fieldProp={`${fieldProp}.locationZip`}
                    disabled={areFieldsDisabled}
                    placeholder={(!areFieldsDisabled)? `${translator('enter_text_placeholder')}` : "" }
                />
                {showDemarcLoc?  <div className="additional-textarea-info">
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"demarc_location_capital"} />}
                        value={locationDetails.demarcLocation}
                        placeholder={isDisabledPerRequestType(requestTypeId, 'demarcLocation') ? '' : `${translator('enter_text_placeholder')}`}
                        maxLength={MAX_LENGTH.limit_500}
                        fieldProp={`${fieldProp}.demarcLocation`}
                        disabled={completed || isDisabledPerRequestType(requestTypeId, 'demarcLocation')}
                    />
                </div> : null
                }
               
            </div>
        )
    }
};

export default AddressDetails